<ion-list *ngIf="isPageReady" [formGroup]="formGroup">
  <ion-item lines="full" class="time-item" [disabled]="timeFormControlParams.date.isDisabled" (click)="displayDateTooltipIfNeeded($event)">
    <ion-label position="fixed">Date:</ion-label>
    <ion-datetime-button datetime="time-component-date">
      <ion-label *ngIf="!formGroup.value.selectedDate" slot="date-target">Select Date</ion-label>
    </ion-datetime-button>
    <ion-note color="danger" *ngFor="let error of getValidationErrors(formGroup.controls.selectedDate)">{{ error }}</ion-note>
  </ion-item>

  <ion-modal [keepContentsMounted]="true">
    <ng-template>
      <ion-datetime
        id="time-component-date"
        showDefaultButtons
        formControlName="selectedDate"
        presentation="date"
        [min]="timeFormControlParams.date.minValue"
        [max]="timeFormControlParams.date.maxValue"
        (ionChange)="onSelectedDateChange($event)"></ion-datetime>
    </ng-template>
  </ion-modal>

  <ion-item class="time-item" lines="full" *ngIf="formGroup.controls.selectedDate.value">
    <ion-label position="fixed">Start Time:</ion-label>
    <time-picker
      [autoSelectTime]="false"
      [defaultDate]="formGroup.controls.selectedDate.value"
      [selectedDateTime]="formGroup.controls.startDateTime.value"
      [minInterval]="effectiveInterval"
      [minTime]="timeFormControlParams.startTime.minValue"
      [maxTime]="timeFormControlParams.startTime.maxValue"
      [disabled]="timeFormControlParams.startTime.isDisabled"
      [timeZoneId]="formGroup.controls.startTimeZoneId.value"
      (onTimeSelect)="onStartTimeChange($event)"></time-picker
    ><br />
    <ion-note color="danger" *ngFor="let error of getValidationErrors(formGroup.controls.startDateTime)">{{ error }}</ion-note>
    <ion-note color="danger" *ngIf="formGroup.controls.isRestBreak.value">Rest breaks are limited to 15 minutes.</ion-note>
  </ion-item>

  <ion-item class="time-item" lines="full" *ngIf="!timeFormControlParams.endTime.isHidden && formGroup.controls.selectedDate.value">
    <ion-label position="fixed">End Time:</ion-label>
    <time-picker
      [autoSelectTime]="false"
      [defaultDate]="formGroup.controls.selectedDate.value"
      [selectedDateTime]="formGroup.controls.endDateTime.value"
      [minInterval]="effectiveInterval"
      [minTime]="timeFormControlParams.endTime.minValue"
      [maxTime]="timeFormControlParams.endTime.maxValue"
      [allowMidnight]="timeFormControlParams.endTime.allowMidnight"
      [midnightSelected]="formGroup.controls.midnightSelectedAsEndDateTime.value"
      [disabled]="timeFormControlParams.endTime.isDisabled"
      [timeZoneId]="formGroup.controls.endTimeZoneId.value"
      (onTimeSelect)="onEndTimeChange($event)"
    ></time-picker>
    <ion-note color="danger" *ngFor="let error of getValidationErrors(formGroup.controls.endDateTime)">{{ error }}</ion-note>
  </ion-item>

  <ion-item lines="full" *ngIf="timeFormControlParams.showClockOutButton && !(!timeFormControlParams.endTime.isHidden && formGroup.controls.selectedDate.value)">
    <ion-label position="fixed">End Time:</ion-label>
    <ion-button color="tetratech" size="small" (click)="onClockOutButtonClick()">Clock Out</ion-button>
  </ion-item>

  <ion-item lines="full" *ngIf="!timeFormControlParams.endTime.isHidden || timeFormControlParams.timeRecordToEditRecordId">
    <ion-label position="fixed">Duration:</ion-label>
    <ion-text [ngClass]="{ 'duration-text': true, 'invalid-duration-text': durationInMinutes <= 0 }">{{ duration }}</ion-text>
  </ion-item>

  <ion-item lines="full" *ngIf="overlappingTimeRecords.length && formGroup.controls.startDateTime.status === 'VALID' && formGroup.controls.endDateTime.status === 'VALID'">
    <div class="full-width">
      <ion-note color="danger">You already have time recorded for the selected range. Please revise the existing time records before adding a new one.</ion-note>
      <ion-list>
        <ng-container *ngFor="let record of overlappingTimeRecords">
          <ion-item class="overlapping-record" lines="none" (click)="onOverlappingRecordClick(record)">
            {{ record.ClockIn | date : 'h:mm a' }} ({{ record.ClockIn | timeZoneAbbreviation : record.ClockInTimeZoneId }}) -
            <ng-container *ngIf="record.ClockOut">{{ record.ClockOut | date : 'h:mm a' }} ({{ record.ClockOut | timeZoneAbbreviation : record.ClockOutTimeZoneId }})</ng-container>
            <ng-container *ngIf="!record.ClockOut">Open</ng-container>
          </ion-item>
        </ng-container>
      </ion-list>
    </div>
  </ion-item>

  <ion-item lines="full" *ngIf="orphanedActivities.length && formGroup.controls.startDateTime.status === 'VALID' && formGroup.controls.endDateTime.status === 'VALID'">
    <div class="full-width">
      <ion-note color="danger"
        >You have notable activities that would fall outside of any time record after this change. Please revise your notable activities before modifying your time record.</ion-note
      >
      <ion-list>
        <ng-container *ngFor="let record of orphanedActivities">
          <ion-item class="overlapping-record" lines="none" (click)="onOrphanedActivityClick(record)"
            >{{ record.UserSpecifiedDate | date : 'h:mm a' }} ({{ record.UserSpecifiedDate | timeZoneAbbreviation : record.TimeZoneId }}) - {{ record.Text }}</ion-item
          >
        </ng-container>
      </ion-list>
    </div>
  </ion-item>

  <ion-item lines="none" *ngIf="!timeFormControlParams.assignmentIsHidden">
    <div class="full-width">
      <app-project-task-selection
        [userId]="userId"
        [assignment]="assignment"
        [selectedDate]="formGroup.controls.selectedDate.value"
        (assignmentSelected)="onChangeAssignment($event)"
        (loadingComplete)="isProjectTaskSelectionComponentLoaded = true"></app-project-task-selection>
    </div>
  </ion-item>
  <ion-note class="invalid-assignment-note" color="danger" *ngIf="isProjectTaskSelectionComponentLoaded && isAssignmentValid !== undefined && !isAssignmentValid">
    Selected work assignment is not valid.
  </ion-note>
  
  <ion-item *ngIf="timeFormControlParams.showBreakTypeButtons" lines="none">
    <ion-segment value="false" (ionChange)="onChangeBreakType($event)">
      <ion-segment-button value="false">
        <ion-label>Meal Break</ion-label>
      </ion-segment-button>
      <ion-segment-button value="true">
        <ion-label>Rest Break</ion-label>
      </ion-segment-button>
    </ion-segment>
  </ion-item>
</ion-list>
